import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import { useDispatch, useSelector } from "react-redux";
import { isArray } from "lodash";
import WorkflowElement from "../../app/components/WorkflowElement";
import {
  getSubFormBprmForm,
  loadSubFormBprmForm,
} from "../../app/store/subForm";

const SubForm = (props) => {
  const {
    showHide,
    handleModalShowHide,
    title,
    formDD,
    subFormId,
    subformItemIndex,
    workflowTask,
    handleSubformSave,
    aWorkfinityAppEntity,
    subFormDataType,
    subFormAttribute,
    handleEditSubForm,
    comp,
  } = props;

  const [wfForm, setWfForm] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(false);
  const [subFormObj, setSubFormObj] = useState(null);

  const subFormBprmFormSelector = useSelector(getSubFormBprmForm);

  const dispatch = useDispatch();
  useEffect(() => {
    if (subFormId > 0) dispatch(loadSubFormBprmForm(subFormId));
  }, [subFormId]);

  useEffect(() => {
    if (subFormBprmFormSelector) setWfForm(subFormBprmFormSelector);
  }, [subFormBprmFormSelector]);

  useEffect(() => {
    if (subformItemIndex > -1 && aWorkfinityAppEntity) {
      if (formDD.length > 0 && comp?.itemColumns) {
        const subformColumns = comp.itemColumns;
        const subfDd = subformColumns[0].ObjectAttributeType;
        const formData =
          aWorkfinityAppEntity[subFormDataType?.toLowerCase()][
          subFormAttribute
          ];
        if (!formData) return;

        let dataArray = [];
        if (!isArray(formData)) dataArray.push(formData);
        else dataArray = formData;

        if (dataArray.length > 0 && subfDd) {
          const subFormObj = {};
          Object.keys(dataArray[subformItemIndex]).map((val) => {
            subFormObj[subfDd.toLowerCase() + "." + val.replace("@", "")] =
              dataArray[subformItemIndex][val];
          });
          setSubFormObj(subFormObj);
        }
      }
    }
  }, [subformItemIndex]);

  const handleNextTask = (data) => {
    const subFormObj = {};
    Object.keys(data).forEach(function (keyValue) {
      const dd = keyValue.split(".");
      if (dd.length > 1) {
        var item = data[keyValue];
        subFormObj["@" + dd[1]] = item;
      }
    });
    handleSubformSave(subFormObj, subFormDataType, subFormAttribute);
    handleModalShowHide("showHide" + subFormId);
    setSaveBtnProcessStatus(false);
  };

  return (
    <React.Fragment>
      <Modal show={showHide} size="xl">
        <Modal.Header
          closeButton
          onHide={() => handleModalShowHide("showHide" + subFormId)}
        >
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="border">
          <div className="row">
            <div className="col-md-12">
              {wfForm && (
                <WorkflowElement
                  wfForm={wfForm}
                  wfTask={workflowTask}
                  handleNextTask={handleNextTask}
                  wfTaskType="subform"
                  setSaveBtnProcessStatus={setSaveBtnProcessStatus}
                  saveBtnProcessStatus={saveBtnProcessStatus}
                  subFormObj={subFormObj}
                />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => handleModalShowHide("showHide" + subFormId)}
          >
            <i className="fa fa-times mr-1" aria-hidden="true"></i>Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default SubForm;
